import { useFormContext, useWatch } from "react-hook-form";
import { useMxMapLayoutContext } from "../context/MxMapLayout";
import { useCallback, useMemo } from "react";
import MxMapViewer from "@rf-l1/map-v2/components/MxMapViewer";

type TGestureHandling = "cooperative" | "greedy" | "none" | "auto";

interface MxMapLayoutMapProps {
  gestureHandling?: TGestureHandling;
}

const MxMapLayoutMap = (props: MxMapLayoutMapProps) => {
  const { fieldsNames } = useMxMapLayoutContext();
  const { control, setValue, trigger } = useFormContext();
  const [lat, lng] = useWatch({
    control,
    name: [fieldsNames?.lat, fieldsNames?.lng]
  });

  const handleClickMap = useCallback((e: any, map: any) => {
    setValue(fieldsNames?.lat, e?.detail?.latLng?.lat, {
      shouldTouch: true,
      shouldDirty: true
    });
    setValue(fieldsNames?.lng, e?.detail?.latLng?.lng, {
      shouldTouch: true,
      shouldDirty: true
    });
    trigger(fieldsNames?.lat);
    trigger(fieldsNames?.lng);
  }, []);

  const handleDragEndMap = useCallback((e: any, map: any) => {
    setValue(fieldsNames?.lat, e.latLng.lat(), {
      shouldTouch: true,
      shouldDirty: true
    });
    setValue(fieldsNames?.lng, e.latLng.lng(), {
      shouldTouch: true,
      shouldDirty: true
    });
    trigger(fieldsNames?.lat);
    trigger(fieldsNames?.lng);
  }, []);

  const latLng = useMemo(() => {
    return {
      lat: lat || 0,
      lng: lng || 0
    };
  }, [lat, lng]);

  return (
    <MxMapViewer
      onClick={handleClickMap}
      onDragEnd={handleDragEndMap}
      lat={latLng.lat}
      lng={latLng.lng}
      gestureHandling={props.gestureHandling}
    />
  );
};

export default MxMapLayoutMap;
